import { createFileRoute } from "@tanstack/react-router";
import AdminPartsOrders from "@/pages/admin/AdminPartsOrders";

export const Route = createFileRoute("/_adminLayout/admin/parts/orders/")({
  component: AdminPartsOrders,
});